var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialEsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7575_15185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 28C8 16.9543 16.9543 8 28 8C39.0457 8 48 16.9543 48 28C48 39.0457 39.0457 48 28 48C16.9543 48 8 39.0457 8 28Z",
    fill: "#EAD6F1"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7575_15185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5151 28.1892C35.8723 28.1893 35.255 28.4398 34.7938 28.8875L33.813 28.3971C34.6136 25.7716 33.1341 22.9942 30.5086 22.1936C29.5482 21.9008 28.5216 21.9057 27.5641 22.2077L26.9892 21.1698C27.9119 20.1594 27.8409 18.5923 26.8305 17.6696C25.8201 16.7469 24.253 16.8179 23.3303 17.8283C22.4075 18.8387 22.4786 20.4058 23.489 21.3285C23.9473 21.7471 24.5461 21.9784 25.1668 21.9766C25.286 21.9732 25.4047 21.9613 25.5222 21.941L26.0921 22.9706C23.9335 24.5724 23.4491 27.6048 25.0011 29.7994L22.5873 32.1187C21.3068 31.5453 19.8038 32.1184 19.2303 33.399C18.6569 34.6795 19.23 36.1825 20.5106 36.756C21.7911 37.3294 23.2941 36.7563 23.8676 35.4757C24.1871 34.7623 24.1603 33.9414 23.7951 33.2502L26.1608 30.9764C28.3714 32.5775 31.4612 32.0848 33.0642 29.8756L34.0582 30.3726C34.0425 30.4724 34.0332 30.5731 34.0301 30.6741C34.0301 32.0465 35.1427 33.1591 36.5151 33.1591C37.8876 33.1591 39.0001 32.0467 39.0001 30.6743C39.0001 29.3018 37.8875 28.1892 36.5151 28.1892Z",
    fill: "#374151"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7575_15185",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.454902 0 0 0 0 0.72549 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7575_15185"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7575_15185",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7575_15185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(19 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialEsg);
export default __webpack_public_path__ + "static/media/socialEsg.66615904c5fdd6c3a4ff482675dbbf21.svg";
export { ForwardRef as ReactComponent };